// @flow

import React, { Component } from "react";

import Title from "../Title";
import Owner from "../Owner";
import Members from "../Members";
import Parent from "../Parent";
import Advanced from "src/containers/chatroom/creator/task/Advanced";
import { Body as FormBody } from "src/styles/form";

import type { UID, RoomId } from "src/types";

type Email = {
  email: string,
};

type Props = {
  title: string,
  advanced: boolean,
  owner: ?UID,
  currentUser: UID,
  parent: ?RoomId,
  members: Array<UID | Email>,
  setConversationAttribute: Function,
  setConversationAttribute: Function,
  handleChange: Function,
  handleOwner: Function,
  handleMembers: Function,
  handleParent: Function,
};

type State = {
  showParent: boolean,
};

class Task extends Component<Props, State> {
  state = {
    showParent: false,
  };

  componentDidMount() {
    const { currentUser, parent, owner, setConversationAttribute } = this.props;
    setConversationAttribute({ id: "members", value: [currentUser] });

    if (!owner) {
      setConversationAttribute({ id: "owner", value: currentUser });
    }
    this.setState({
      showParent: !!parent,
    });
  }

  render() {
    const {
      title,
      owner,
      advanced,
      members,
      parent,
      handleOwner,
      handleMembers,
      handleChange,
      handleParent,
    } = this.props;

    const { showParent } = this.state;
    return (
      <FormBody>
        <Title title={title} handleChange={handleChange} />
        <Owner owner={owner} handleOwner={handleOwner} />
        <Members members={members} handleMembers={handleMembers} />
        {showParent && !advanced ? (
          <Parent parent={parent} handleParent={handleParent} />
        ) : null}

        {advanced ? <Advanced {...this.props} /> : null}
      </FormBody>
    );
  }
}

export default Task;
